import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { retrieveUserLogins } from '../../../../../../redux/actions/user'
import DashboardAccountRightContainerLoginHistoryTableRow from './table-row'

import './style.scss'

const Index = () => {

    const dispatch = useDispatch()
    const userId = useSelector(state => state && state.user && state.user.details && state.user.details.id)
    const loginHistory = useSelector(state => state.user.logins)
    const loading = useSelector(state => state.user.fetchLogins.loading)

    useEffect(() => {
        if(userId){
            dispatch(retrieveUserLogins(userId))
        }
    }, [userId])

    if(!loading)

    return(
        <table className="login-history-table">
            <tr>
            <th>Dato</th>
            <th>Lokasjon</th>
            <th>Leverandør</th>
            <th>IP addresse</th>
        </tr>
            {loginHistory.map((login) => {
                return(
                    <DashboardAccountRightContainerLoginHistoryTableRow login={login}/>
                )
            })}
        </table>
    )

    return null
}

export default Index